const MIN_AMBIENT_CLASSES = 2;
const MAX_AMBIENT_CLASSES = 7;

export const getAmbientClassCount = (ambient, fallback = MIN_AMBIENT_CLASSES) => {
  const explicitCount = Number(ambient?.params?.breaks ?? ambient?.params?.num_classes);

  if (Number.isFinite(explicitCount) && explicitCount >= MIN_AMBIENT_CLASSES) {
    return Math.min(Math.max(Math.trunc(explicitCount), MIN_AMBIENT_CLASSES), MAX_AMBIENT_CLASSES);
  }

  const classIndexes = (ambient?.geojson?.features || [])
    .map((feature) => Number(feature?.properties?.cls))
    .filter(Number.isFinite);
  const maxClassIndex = Math.max(...classIndexes);

  if (Number.isFinite(maxClassIndex)) {
    return Math.min(Math.max(Math.trunc(maxClassIndex) + 1, MIN_AMBIENT_CLASSES), MAX_AMBIENT_CLASSES);
  }

  return Math.min(Math.max(Math.trunc(Number(fallback)) || MIN_AMBIENT_CLASSES, MIN_AMBIENT_CLASSES), MAX_AMBIENT_CLASSES);
};

export const getAmbientDisplayClassNumber = (classIndex, classCount) => {
  const normalizedIndex = Number(classIndex);
  const normalizedCount = Math.min(
    Math.max(Math.trunc(Number(classCount)) || MIN_AMBIENT_CLASSES, MIN_AMBIENT_CLASSES),
    MAX_AMBIENT_CLASSES
  );

  if (!Number.isFinite(normalizedIndex)) {
    return null;
  }

  return normalizedCount - Math.trunc(normalizedIndex);
};

export const getAmbientClassLabel = ({classIndex, classCount, classWord = "Clase"}) => {
  const displayNumber = getAmbientDisplayClassNumber(classIndex, classCount);
  return displayNumber == null ? classWord : `${classWord} ${displayNumber}`;
};
